export default "__VITE_ASSET__C3hqOcjy__ 100w";